export function getSelectedDates(startDate, endDate){
  var _selected_dates = [];
  var i = startDate;
  if (isNaN(endDate) || typeof endDate == "string"){
    endDate = startDate;
  }

  while (i <= endDate) {
    _selected_dates.push(i);
    if (new Date(i * 1000).getHours() == 23){
      i += 86400;
      i += 3600;
    } else if (new Date(i * 1000).getHours() == 1){
      i += 86400;
      i -= 3600;
    } else {
      i += 86400;
    }
  }
  return _selected_dates;
}


export function convert_date_to_timestamp(date){

  if (date == null) {
    return '';
  }

  return new Date(date).setHours(0,0,0,0) / 1000;
}

export function format_date(dateObject, type, endDateObject) {
  if (!is_valid_date(dateObject))
    return '';

    var monthNames = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ],
    dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    day = dateObject.getDay(),
    date = dateObject.getDate(),
    monthIndex = dateObject.getMonth(),
    year = dateObject.getFullYear();

  if (endDateObject) {
    var end_day = endDateObject.getDay(),
        end_date =  endDateObject.getDate();


  }


  if (type == "day"){
    return dayNames[day] + ' ' + date +  nth(date) + ' ' + monthNames[monthIndex];
  } else if (type == "week") {
    return dayNames[day] + ' ' + date + nth(date) + ' - ' + dayNames[end_day] + ' ' + end_date + ' ' + monthNames[monthIndex];



  } else if (type == "month") {
    return monthNames[monthIndex] + ' ' + year;

  } else if (type == "year") {
    return year;
  } else {

  }

  return dayNames[day] + ' ' + date +  nth(date) + ' ' + monthNames[monthIndex];
}

export function nth(n){return n>3&&n<21?"th":n%10==1?"st":n%10==2?"nd":n%10==3?"rd":"th"}


export function format_date_full(dateObject, type, endDateObject) {
  if (!is_valid_date(dateObject))
    return '';

    var monthNames = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ],
      dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      day = dateObject.getDay(),
      date = dateObject.getDate(),
      monthIndex = dateObject.getMonth(),
      year = dateObject.getFullYear();

    return date + nth(date) + ' ' + monthNames[monthIndex];
}

export function format_dates(dates){
  let start_date = '',
      end_date = '';

  if (typeof dates[0] != "undefined" && dates[0] != false) {
    start_date = format_date(new Date(dates[0]))
  }

  if (typeof dates[1] != "undefined" && dates[1] != false) {
    end_date = format_date(new Date(dates[1]))
  }

  if (start_date.length && end_date.length && start_date != end_date){
    return start_date + " - " + end_date;
  }

  if (start_date.length) {
    return start_date;
  }

  return 'no date selected';
}


export function is_valid_date(d) {
  return d instanceof Date && !isNaN(d);
}


export function is_in_timerange(hour, time_range){

  var hour = parseInt(hour);
  var p = "evening";
  if (hour > 2 && hour < 6){
    p = "morning";
  } else if (hour > 6 && hour < 18){
    p = "afternoon";
  }

  if (p == time_range){
    return true;
  } else {
    return false;
  }
}



export function get_days(show_today) {
  const timestamps = [];
  const today = new Date();
  today.setHours(0,0,0,0);
  

  for (let i = 0; i < 21; i++) {

    let currentDate = new Date(today.getTime() + (i * 24 * 60 * 60 * 1000));
    if (currentDate.getHours() == 23){
      currentDate = currentDate.getTime() + 3600000;
    } else if (currentDate.getHours() == 1){
      currentDate = currentDate.getTime() - 3600000;
    } else {
      currentDate = currentDate.getTime();
    }

  
    let formattedDate = format_date(new Date(currentDate), 'day');


    if (i == 0 && show_today){
       formattedDate = "Today";
    }


    timestamps.push({
      name: formattedDate,
      value: currentDate / 1000,
    });
  }


  return timestamps;
}


export function getPreviousMonday(date) {
  const dayOfWeek = date.getDay(); // 0 for Sunday, 1 for Monday, ..., 6 for Saturday
  const daysUntilPreviousMonday = (dayOfWeek === 0 ? 6 : dayOfWeek - 1);
  const previousMonday = new Date(date);
  previousMonday.setDate(date.getDate() - daysUntilPreviousMonday);
  return previousMonday;
}

export function get_weeks(show_today) {
  const today = new Date();

  // Check if today is not Monday
  if (today.getDay() !== 1) {
    // If today is not Monday, find the previous Monday
    const previousMonday = getPreviousMonday(today);
    today.setTime(previousMonday.getTime());
  }

  const timestamps = [];

  for (let i = 0; i < 12; i++) {
    const nextMonday = new Date(today);
    nextMonday.setDate(today.getDate() + i * 7); // Add 7 days for each week
    nextMonday.setHours(0,0,0,0);

    let nextSunday = new Date(nextMonday.getTime() + (6 * 24 * 60 * 60 * 1000));

    let formattedDate = format_date(nextMonday, 'week', nextSunday);
    // let formattedSundayDate = format_date(nextSunday, 'week');


    timestamps.push({
      name: formattedDate,
      value: nextMonday.getTime() / 1000
    });

  }

  return timestamps;
}

export function get_last_day_of_month(firstDayOfMonth) {

  const lastDay = new Date(firstDayOfMonth * 1000);
  lastDay.setMonth(lastDay.getMonth() + 1);
  lastDay.setDate(0);
  lastDay.setHours(0,0,0,0);

  return lastDay.getTime() / 1000;
}

export function get_months(show_today){
  const today = new Date();
  const timestamps = [];

  for (let i = 0; i < 12; i++) {
    const nextMonth = new Date(today);
    nextMonth.setMonth(today.getMonth() + i);

    nextMonth.setDate(1);
    nextMonth.setHours(0,0,0,0);

    let formattedDate = format_date(nextMonth, 'month');

    timestamps.push(
      {
        name: formattedDate,
        value: nextMonth.getTime() / 1000
      }
    );
  }

  return timestamps;
}


export function get_last_day_of_year(date) {
  const year = new Date(date * 1000).getFullYear();
  const lastDayOfYear = new Date(year, 11, 31);
  lastDayOfYear.setHours(0,0,0,0);
  return lastDayOfYear.getTime() / 1000;
}


export function get_years(show_today){
  const currentYear = new Date().getFullYear();

  const timestamps = [];

  for (let i = 0; i < 5; i++) {
    const year = currentYear + i;
    const firstDayOfYear = new Date(year, 0, 1);

    firstDayOfYear.setHours(0,0,0,0);

    let formattedDate = format_date(firstDayOfYear, 'year');

    timestamps.push(
      {
        name: formattedDate,
        value: firstDayOfYear.getTime() / 1000
      }
    )


  }
  return timestamps


}


export function format_date_datepicker(data){
  if (data){
    const date = new Date(data);
    let yyyy = date.getFullYear();
    let mm = date.getMonth() + 1;
    let dd = date.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return dd + '/' + mm + '/' + yyyy;
  } else {
    return "DD/MM/YYYY";
  }

}
